import { useEffect } from 'preact/hooks';
import type { ComponentChildren } from 'preact';

export function Sheet({ title, onClose, children }: { title: string; onClose: () => void; children: ComponentChildren }) {
  useEffect(() => {
    const on = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    addEventListener('keydown', on);
    document.body.classList.add('locked');
    return () => {
      removeEventListener('keydown', on);
      document.body.classList.remove('locked');
    };
  }, []);
  return (
    <div class="scrim" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div class="sheet" role="dialog" aria-modal="true" aria-label={title}>
        <header class="row">
          <h2>{title}</h2>
          <button class="icon" aria-label="Close" onClick={onClose}>✕</button>
        </header>
        {children}
      </div>
    </div>
  );
}
